// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__22rnc","inner":"Form_inner__XJAmk","range":"Form_range__2IP2A","name":"Form_name__1yK2z","actions":"Form_actions__3APuL"};